<template>
  <el-dialog
    :title="dialogType === 'create' ? 'Hozzáadás' : 'Szerkesztés'"
    :append-to-body="true"
    :visible="visible"
    :close-on-click-modal="false"
    width="350px"
    @open="onOpen"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :model="item"
      label-position="top"
    >
      <el-form-item
        label="Egységár"
      >
        <el-input-localized-numeric
          v-model="item.unit_price"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['visible', 'defaultItem', 'customerId'],
  data() {
    return {
      item: {
      },
      dialogType: 'create',
      loading: false,
    };
  },
  methods: {
    async store() {
      this.item.net_price = this.item.unit_price * this.item.count * this.item.count_per_pack;
      this.$emit('change', this.item);
      this.$emit('close');
    },
    async onOpen() {
      this.loading = true;
      this.setItem();
      if (this.item.key || this.item.id) {
        this.dialogType = 'update';
      } else {
        this.dialogType = 'create';
      }
      this.loading = false;
    },
    setItem() {
      this.item = { ...this.defaultItem };
    },
  },
};
</script>
